import type { CoverageStatusKey } from "@platform/plan-grid-core";

/**
 * The Launchpad's status vocabulary.
 *
 * Three of the four words are the Build tab's own and are reused rather than
 * restated. `Extract` over `CoverageStatusKey` is the mechanism: renaming a key
 * in `@platform/plan-grid-core` fails this build instead of letting the
 * Launchpad drift into a parallel vocabulary.
 *
 * The Build tab's fourth state, `manual-review-needed` ("Manual Completion"),
 * is deliberately not here. It records a human filling something in, which a
 * read-only surface reporting one Rumi run can never show.
 */
export type RunStateKey =
  | Extract<
      CoverageStatusKey,
      "complete" | "partially-pre-populated" | "awaiting-input"
    >
  /**
   * The run says nothing about this item. The one word the Launchpad adds:
   * below document level nothing shipped separates "found nothing" from "never
   * looked", which is the line the Document Library draws as Excluded.
   */
  | "not-reported";

/**
 * Display strings, verbatim from the Build tab. "Not reported" is sentence
 * case where the other three are title case; that is the settled spelling, not
 * an oversight.
 */
export const RUN_STATE_LABELS: Record<RunStateKey, string> = {
  complete: "Complete",
  "partially-pre-populated": "Partially Extracted",
  "awaiting-input": "Awaiting Input",
  "not-reported": "Not reported",
};
